export const calculateSolde = (totalFacture, timbre,tva, commission, comtax) => {
    let solde = 0;
    if (timbre && totalFacture && commission && comtax) {
        solde = 
            parseFloat(timbre) + 
            parseFloat(totalFacture) + 
            parseFloat(tva) + 
            parseFloat(commission) + 
            parseFloat(comtax);
    }
    return solde;
};
